import { useRef, useState } from "react";
import moment from "moment";
import { getTwoMonthsAgoDate, switchString } from "../../utils/utils";
import { Autocomplete, Button, Input, Modal, Spinner, Toggle } from "src/components";
import downArrow from "src/assets/down-arrow.svg";
import { downloadInvoice, editInvoice, getInvoiceChangeValidationV1, getInvoiceDetails, postInvoiceRemark, uploadInvoice } from "src/services/invoice-api"; //M10-11703
import { generateUniqueID } from "src/constants/functions";
import InvoiceReject from "./invoice-reject";
import InvoiceReassign from "../invoice-master/InvoiceReassign";
import Contact from "src/assets/Contact.svg";
import { toast } from "src/hooks/useToast";
import { useEventStatus } from "src/hooks/useEventStatus";
import { invoiceActions } from "src/context/invoice-slice";
import { useDispatch, useSelector } from "react-redux"; //M10-11703
import { counterActions } from "src/context/counter-slice";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import useDebounceLeading from "src/hooks/useDebounceLeading";
import EscalateToMaster from "./InvoiceEntryCards/EscalateToMaster";
import { validateInvoiceNumber } from "./invoice-constants"; //M10-11021
//M10-11703
import crossIcon from "src/assets/cross.svg";
import { RootState } from "src/context/store";
//M10-11703

interface InvoiceDetailCardProps {
  status: string;
  data: any;
  checkDataType: boolean;
  viewDetails?: boolean;
  isExpandable?: boolean;
  isExpandedInitial?: boolean;
  isCompleted?: boolean;
  isEntry?: boolean;
  index?: number;
  invoiceData?: any;
  showHeader?: boolean;
  fetchInvoiceDetails?: any;
  tab: number;
  isEwayExempt?: boolean;
  isMapped?: boolean; //M10-11117
}

const InvoiceDetailCard = ({
  data,
  checkDataType = true,
  status,
  isCompleted = false,
  invoiceData,
  showHeader = true,
  tab,
  isEwayExempt,
  isMapped = true  //M10-11117
}: InvoiceDetailCardProps) => {
  const [invoiceNumber, setInvoiceNumber] = useState<string>(data?.["Invoice no."]);
  const [invoiceDate, setInvoiceDate] = useState<string>(data?.["Invoice date"]);
  const [qrIRN, setQrIRN] = useState<any>(data?.["QR/IRN"]);
  const [irnNumber, setIrnNumber] = useState<string>(data?.["Irn Number"]);
  const [gstStatus, setGstStatus] = useState<string>(data?.["GST Applicability"]); //M10-11546
  const [dlValidated, setdlValidated] = useState<string>(data?.["DL Present"]);
  const [mciValid, setMciValid] = useState<string>(data?.["MCI Validated"]);
  const [isExpanded, setIsExpanded] = useState(tab !== 1);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [escalateToMasterOpen, setEscalateToMasterOpen] = useState(false);
  const [StampSeal, setStampSeal] = useState<string>(data?.["Stamp & Sign Status"]);
  const [category1, setCategory1] = useState<string>(data?.["E-Inv"]);
  //M10-11703
  const [poReason, setPoReason] = useState<string>('');
  const [poProportionate, setPoProportionate] = useState<string>(data?.["Po Proportionate Exempt"]);
  const [isPoProportionate, setIsPoProportionate] = useState(false);
  const { idTokenDetails } = useSelector((state: RootState) => state.auth);
  //M10-11703

  //M10-11086
  const [IRNValidation, setIRNValidation] = useState<boolean>(
    invoiceData?.invoice?.e_inv_ref_type === "IRN" ||
    invoiceData?.invoice?.e_inv_ref_type === "BOTH"
  );
  const [IRNExempt, setIRNExempt] = useState<any>(invoiceData?.invoice?.irn_exempt);
  //M10-11086

  const company_code = invoiceData?.company_code;

  const catTwoAndThree =
    invoiceData?.einvack_type_code === "Upload E-Inv Aknowledgement Copy separately" ||
    invoiceData?.einvack_type_code === "Periodic Bulk Upload of E-Invoice";

  const { withEventCheck } = useEventStatus();

  const [modalStates, setModalStates] = useState({
    reject: false,
    reassign: false,
    hold: false,
  });

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    setInvoiceNumber(inputValue);
  };

  function isValidDatePartsInISODate(dateStr: any) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T/.exec(dateStr);
    if (!match) return false;

    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const day = parseInt(match[3], 10);

    // Validate year range
    if (year < 1900 || year > 2100) return false;

    // Validate month
    if (month < 1 || month > 12) return false;

    // Validate day
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (day < 1 || day > daysInMonth[month - 1]) return false;

    return true;
  }

  const verifyStringType = function (input: string) {
    const date = new Date(input);
    const numberRegex = /^\d+$/;
    if (!isNaN(date.getTime()) && input.trim() !== "" && !numberRegex.test(input)) {
      return moment(input).format("DD MMM, YYYY");
    } else {
      return input;
    }
  };
  const isRequestInProgress = useRef(false);

  const handleSubmitInvoice = useDebounceLeading(async () => {
    if (isRequestInProgress.current) return;
    isRequestInProgress.current = true;
    try {
      //M10-11703
      if (isPoProportionate && !poReason.trim()) {
        toast({
          description: "Reason is required",
          variant: "destructive",
        });
        return;
      }
      //M10-11703
      //M10-11021
      let vertifyResult = validateInvoiceNumber(invoiceNumber)
      if (!vertifyResult.valid) {
        toast({ description: vertifyResult?.error, variant: "destructive" });
        return;
      }
      //M10-11021
      if (invoiceData?.eWayBillDtl?.einvoice_status === "pending" && !isEwayExempt) {
        toast({ description: "E-Way Bill not verified", variant: "destructive" });
        return;
      }
      if (invoiceDate == undefined || invoiceDate == "" || invoiceDate == null || invoiceDate == " ") {
        toast({ description: "Select Invoice Date before updating", variant: "destructive" });
        return;
      }
      //M10-11134
      if (new Date(invoiceDate) > new Date()) {
        toast({ description: "Invoice date cannot be in the future", variant: "destructive" });
        return;
      }
      //M10-11134
      if (!isValidDatePartsInISODate(invoiceDate)) {
        toast({ description: "Invoice Date is Incorrect.", variant: "destructive" });
        return;
      }

      if (
        (
          (!qrIRN || qrIRN == null) &&
          data?.["E-Inv.Applicability"] == "Yes" &&
          !catTwoAndThree
        ) ||
        (
          category1 == 'Yes' &&
          (!qrIRN || qrIRN == null)
        )
      ) {
        toast({ description: "Add QR/IRN", variant: "destructive" });
        return;
      }

      //M10-11086
      if (!IRNExempt) {
        if (
          (irnNumber.trim() !== 'IMAGE FILE' &&
            data?.["E-Inv.Applicability"] == "Yes" &&
            !catTwoAndThree &&
            qrIRN &&
            qrIRN !== "QR" &&
            irnNumber.trim().length !== 64) || (
            irnNumber.trim() !== 'IMAGE FILE' &&
            category1 == 'Yes' &&
            qrIRN &&
            qrIRN !== "QR" &&
            irnNumber.trim().length !== 64)
        ) {
          toast({ description: "IRN should be 64 digit", variant: "destructive" });
          return;
        }
      }

      // if (((qrIRN == "IRN" || qrIRN == "BOTH") && irnNumber == " ") || irnNumber == "") {
      //   toast({ description: "Add IRN Number", variant: "destructive" });
      //   return;
      // }

      // if (gstStatus == "Yes" && !invoiceData?.counter_gst_number?.trim()) {
      //   toast({ description: "GST not validated", variant: "destructive" });
      //   return;
      // }
      if (gstStatus == "No" && invoiceData?.counter_gst_status) {
        toast({ description: "Validate GST Applicability as YES", variant: "destructive" }); //M10-11546
        return;
      }
      // if (dlValidated == "Yes" && !invoiceData?.counter_dl_number?.trim()) {
      //   toast({ description: "DL not validated", variant: "destructive" });
      //   return;
      // }
      // if (mciValid == "Yes" && !invoiceData?.counter_mci_number?.trim()) {
      //   toast({ description: "MCI not validated", variant: "destructive" });
      //   return;
      // }

      // if (data?.["Link Type"] == "DRDS" && mciValid == "Yes" && !invoiceData?.counter_mci_number?.trim()) {
      //   toast({ description: "MCI not validated", variant: "destructive" });
      //   return;
      // }
      if (data?.["Link Type"] == "DRDS" && mciValid == "No" && invoiceData?.counter_mci_number?.trim()) {
        toast({ description: "Validate MCI Validated as YES", variant: "destructive" });
        return;
      }
      // if (data?.["Link Type"] == "DRDS" && mciValid == "No" && !invoiceData?.counter_mci_number?.trim()) {
      //   toast({ description: "MCI not validated", variant: "destructive" });
      //   return;
      // }
      // if (data?.["Link Type"] == "DRDS" && gstStatus == "Yes" && !invoiceData?.counter_gst_number?.trim()) {
      //   toast({ description: "GST not validated", variant: "destructive" });
      //   return;
      // }
      // if (
      //   (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
      //   dlValidated == "Yes" &&
      //   (!invoiceData?.counter_dl_number?.trim() || invoiceData?.counter_dl_number?.trim() == undefined)
      // ) {
      //   toast({ description: "DL not validated", variant: "destructive" });
      //   return;
      // }
      // if (
      //   (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
      //   dlValidated == "No" &&
      //   (!invoiceData?.counter_dl_number?.trim() || invoiceData?.counter_dl_number?.trim() == undefined)
      // ) {
      //   toast({ description: "DL not validated", variant: "destructive" });
      //   return;
      // }
      if (
        (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
        dlValidated == "No" &&
        invoiceData?.counter_dl_number?.trim()
      ) {
        toast({ description: "Validate DL Present as YES", variant: "destructive" });
        return;
      }
      // if (
      //   (data?.["Link Type"] == "DRAPH" || data?.["Link Type"] == "INDPH-PH" || data?.["Link Type"] == "INDPH-HS") &&
      //   gstStatus == "Yes" &&
      //   (!invoiceData?.counter_gst_number?.trim() || invoiceData?.counter_gst_number?.trim() == undefined)
      // ) {
      //   toast({ description: "GST not validated", variant: "destructive" });
      //   return;
      // }

      setIsLoading(true);

      const currentDate = new Date(invoiceDate);
      const currentYear = currentDate.getFullYear();
      const financialYearStart = new Date(currentDate.getMonth() >= 3 ? currentYear : currentYear - 1, 3, 1);

      const invoiceAccYear = financialYearStart.getFullYear();

      const payloadToValidateInV1 = {
        cmpstockistcode: invoiceData?.company_stockist_code,
        invoicenumber_searchcolumn: invoiceNumber || data?.["Invoice no."] || "",
        invoice_accyear: invoiceAccYear,
        company_code: invoiceData?.company_code,
      };
      //M10-11703
      if (!poReason.trim()) {
        const response = await getInvoiceChangeValidationV1(payloadToValidateInV1);
        if (response?.data?.success !== "success") {
          toast({ description: response?.data?.message, variant: "destructive" });
          setIsLoading(false);
          return;
        }
      }
      //M10-11703

      const payload = {
        data: {
          invoice_status: invoiceData?.fileStatusHdr?.fuid_status_shortcode,
          stockist_id: invoiceData?.stockist_id,
          stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
          u_code: generateUniqueID(),
          new_invoice_date: invoiceDate,
          invoice_number: invoiceNumber ? invoiceNumber.trim() : data?.["Invoice no."] || "",
          ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
          irn: qrIRN == "IRN" || qrIRN == "BOTH" ? irnNumber.trim() : "",
          gst_validated: gstStatus == "Yes" ? true : false,
          dl_validated: dlValidated == "Yes" ? true : false,
          mci_validated: mciValid == "Yes" ? true : false,
          counter_gst_number: invoiceData?.counter_gst_number || "",
          counter_dl_number: invoiceData?.counter_dl_number || "",
          counter_mci_number: invoiceData?.counter_mci_number || "",
          stamp_and_seal_validated: StampSeal == "Yes" ? true : false,
          is_category_1: category1 == "Yes" ? true : false,
          irn_exempt: IRNExempt, //M10-11086
        },
        event_type: "INVOICE_ADD",
      };

      const payload2 = {
        data: {
          invoice_status: invoiceData?.fileStatusHdr?.fuid_status_shortcode,
          invoice_id: invoiceData?.invoice?.invoice_id,
          invoice_number: invoiceNumber?.trim(),
          u_code: invoiceData?.invoice?.u_code,
          new_invoice_date: invoiceDate,
          stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
          stockist_id: invoiceData?.stockist_id,
          ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
          irn: qrIRN == "IRN" || qrIRN == "BOTH" ? irnNumber.trim() : "",
          gst_validated: gstStatus == "Yes" ? true : false,
          dl_validated: dlValidated == "Yes" ? true : false,
          mci_validated: mciValid == "Yes" ? true : false,
          counter_gst_number: invoiceData?.counter_gst_number || "",
          counter_dl_number: invoiceData?.counter_dl_number || "",
          counter_mci_number: invoiceData?.counter_mci_number || "",
          header_edit: true,
          invoice_num_modified: invoiceData?.invoice?.invoice_number?.trim() !== invoiceNumber?.trim(),
          stamp_and_seal_validated: StampSeal == "Yes" ? true : false,
          is_category_1: category1 == "Yes" ? true : false,
          irn_exempt: IRNExempt, //M10-11086
          ...(invoiceData?.invoice?.invoiceProducts.some((item: any) => item?.orderProductMappings.some((m: any) => m.is_po_generated === false)) && { po_proportionate_exempt_invoice: poProportionate == "No" ? "Yes" : "No" }), //M10-11703
          counter_data_validation:
            invoiceData?.invoice?.dl_validated !== (dlValidated == "Yes" ? true : false) ||
            invoiceData?.invoice?.gst_validated !== (gstStatus == "Yes" ? true : false) ||
            invoiceData?.invoice?.mci_validated !== (mciValid == "Yes" ? true : false),
        },
        primary_key: invoiceData?.invoice?.invoice_id,
        event_type: "INVOICE_EDIT",
      };

      if (invoiceData?.invoice == null) {
        const res = await uploadInvoice(payload, company_code);
        const response = await withEventCheck(
          () => {
            return getInvoiceDetails(invoiceData?.stockist_invoice_attachment_id as string, false, company_code);
          },
          res?.data?.data?.eventStreamCreated?.streamId
        );
        dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));
      } else {
        const res = await editInvoice(payload2, company_code);
        setPoProportionate(poProportionate == "No" ? "Yes" : "No");  //M10-11703
        const response = await withEventCheck(
          () => {
            return getInvoiceDetails(invoiceData?.stockist_invoice_attachment_id as string, false, company_code);
          },
          res?.data?.data?.invoice?.eventStreamCreated?.streamId
        );
        if (Number(tab) === 1) {
          dispatch(invoiceActions?.setInvoiceApprovalData(response?.data?.data));
        } else {
          dispatch(invoiceActions?.setInvoiceDetails(response?.data?.data));
        }
      }
      //M10-11703
      if (poReason.trim()) {
        const remarkPayload = {
          data: {
            invoice_remarks_hdr: 22,
            invoice_id: invoiceData?.invoice?.invoice_id ? invoiceData?.invoice?.invoice_id : null,
            stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
            freetxt_remarks: `Proportionate Exempt Reason: ${poReason}`,
            remarkby_type: idTokenDetails?.["custom:role"],
            is_private: false,
          },
          primary_key: invoiceData?.stockist_invoice_attachment_id,
          event_type: "STOCKIST_INVOICE_REMARK_ADD",
        };
        //M10-11536
        const res = await postInvoiceRemark(remarkPayload, invoiceData?.company_code);
        if (res?.status !== 200) throw new Error();
        setPoReason('')
        setIsPoProportionate(false)
      }
      //M10-11703
      setIsLoading(false);
      toast({ description: "Invoice header submitted", variant: "default" });
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
      console.log(error, "error");
      setIsLoading(false);
    } finally {
      isRequestInProgress.current = false;
    }
  }, 1000);

  const handleCloseModal = (modalName: string) => {
    setModalStates((prev: any) => ({ ...prev, [modalName]: false }));
  };

  return (
    <div className="-mt-10">
      <Modal isOpen={modalStates.reject} isHeader={false} onCloseModal={() => handleCloseModal("reject")} title="Reject Invoice">
        <InvoiceReject invoiceData={invoiceData} onCloseModal={() => handleCloseModal("reject")} />
      </Modal>
      <Modal isOpen={modalStates.reassign} isHeader={false} onCloseModal={() => handleCloseModal("reassign")} title="Reassign Invoice">
        <InvoiceReassign invoiceData={invoiceData} onCloseModal={() => handleCloseModal("reassign")} />
      </Modal>

      {showHeader && (
        <header className={isCompleted ? "flex justify-between w-full" : "flex justify-between w-full px-5 py-5"}>
          <div className="flex flex-col gap-x-2">
            <div className="flex items-center gap-x-2">
              <h1 className="font-semibold text-[1.4rem] mr-4">
                <span className="text-gray-400 text-[1.4rem]">FUID#</span> {invoiceData?.fuid_no}
              </h1>
              <h1
                className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
                style={{
                  backgroundColor: invoiceData?.fileStatusHdr?.color_code?.trim(),
                  color: invoiceData?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {status}
                <img className="w-3 h-3 ml-1" src={downArrow} alt="down-arrow" />
              </h1>
            </div>
          </div>
        </header>
      )}
      {showHeader && (
        <div className="flex justify-between">
          <div className="flex items-center ml-4 gap-x-2">
            <img className="w-6 h-6 ml-1" src={Contact} alt="person-img" />
            <span className="text-[#49484C] text-sm">Assigned to</span>
            <div className="w-10 h-10 bg-[#8051FF] flex items-center justify-center text-[#fff] rounded-full">
              {invoiceData?.InvoiceAssignment?.user_name?.slice(0, 2)}
            </div>
            <span className="text-[#49484C] text-sm">{invoiceData?.InvoiceAssignment?.user_name}</span>
          </div>
          <div className="flex items-center gap-x-2">
            {
              <div className="flex items-center p-2 rounded-md bg-[#f1f1f1]">
                <Button
                  className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
                  onClick={() => {
                    if (!invoiceData?.file_path) {
                      toast({ description: "Invoice not found", variant: "destructive" });
                      return;
                    }
                    downloadInvoice(invoiceData?.file_path, company_code).then((res: any) => {
                      if (res?.data?.success && res?.data?.data) {
                        window.open(res?.data?.data, "_blank");
                      } else {
                        console.error("Failed to download the invoice.");
                      }
                    });
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
                  </svg>
                  <span>Download Invoice</span>
                </Button>
                {invoiceData?.einv_attachment_path && (
                  <Button
                    className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
                    onClick={() => {
                      if (!invoiceData?.einv_attachment_path) {
                        toast({ description: "Invoice not found", variant: "destructive" });
                        return;
                      }
                      downloadInvoice(invoiceData?.einv_attachment_path, company_code).then((res: any) => {
                        if (res?.data?.success && res?.data?.data) {
                          window.open(res?.data?.data, "_blank");
                        } else {
                          console.error("Failed to download the invoice.");
                        }
                      });
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
                    </svg>
                    <span>Download E-Invoice</span>
                  </Button>
                )}
                <Button onClick={() => setEscalateToMasterOpen(true)} className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1]  border-none rounded-none h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span>Escalate to master</span>
                </Button>
                <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 border-l rounded-l-none rounded-r-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 11-12.728 0m12.728 0L12 12m0 0l-6.364-6.364" />
                  </svg>
                  <span>Report an issue</span>
                </Button>
              </div>
            }
          </div>
        </div>
      )}
      {isLoading ? (
        <div className="flex justify-center items-center h-[20vh]">
          <Spinner />
        </div>
      ) : (
        <div
          className={`overflow-hidden items-center transition-all duration-500 px-5 ease-in-out`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          <div className="flex justify-between items-center pb-5 mt-10 border-b-2 border-gray-200">
            <div className="flex items-center gap-x-4">
              <p className="text-xl font-semibold">Header Information</p>
              {/* {!isExpanded && (
                <>
                  {invoiceData?.orderCodes?.length > 0 && (
                    <p className="text-sm text-gray-500 border border-gray-300 rounded-lg p-1 px-2">
                      Order Code: {invoiceData?.orderCodes?.map((code: any) => code?.order_code).join(", ")}
                    </p>
                  )}
                </>
              )} */}
            </div>
            <div className="p-2 bg-[#F1F1F1] border-2 border-gray-200 rounded-md cursor-pointer" onClick={handleToggle}>
              <img className={`transition-transform  duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </div>
          </div>

          <div
            className={`transition-all items-center duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
            style={{ transitionProperty: "max-height, opacity" }}
          >
            <div className={"grid grid-cols-1 w-[100%] py-5 mt-5 xl:grid-cols-3 gap-y-5"}>
              {!!data &&
                Object.keys(data)?.length > 0 &&
                Object.entries(data)?.map(
                  ([key, value]) =>
                    typeof value === "string" &&
                    value !== "" && (
                      <div key={key?.toString()} className={"grid grid-cols-2 -space-x-10 -space-y-0 text-sm xl:grid-cols-2 items-center"}>
                        <p
                          className={`text-[#49484C] place-self-center mr-auto whitespace-break-spaces text-sm leading-[0.02rem] not-italic ${key === "Pharmacy" || key === "Counter" ? "font-bold" : "font-normal"
                            }`}
                        >
                          {switchString(key)} :
                        </p>
                        {key == "GST Applicability" && ( //M10-11546
                          <div className="w-[60%]">
                            {invoiceData?.counter_gst_status ?
                              <Toggle
                                disabled={
                                  invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                  // !data?.["GST No."]?.trim()?.length
                                }
                                checked={gstStatus == "Yes"}
                                onChange={(e: any) => {
                                  setGstStatus(e === true ? "Yes" : "No");
                                }}
                              /> : <p>No</p>
                            }
                          </div>
                        )}
                        {key == "Stamp & Sign Status" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["GST No."]?.trim()?.length
                              }
                              checked={StampSeal == "Yes"}
                              onChange={(e: any) => {
                                setStampSeal(e === true ? "Yes" : "No");
                              }}
                            />
                          </div>
                        )}
                        {key == "E-Inv" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["GST No."]?.trim()?.length
                              }
                              checked={category1 == "Yes"}
                              onChange={(e: any) => {
                                setCategory1(e === true ? "Yes" : "No");
                                if (data?.["E-Inv.Applicability"] === "No" && e === false) {
                                  setQrIRN(null);
                                  setIrnNumber("")
                                }
                              }}
                            />
                          </div>
                        )}
                        {key == "DL Present" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["DL no."]?.trim()?.length
                              }
                              checked={dlValidated == "Yes"}
                              onChange={(e: any) => {
                                setdlValidated(e === true ? "Yes" : "No");
                              }}
                            />
                          </div>
                        )}

                        {key == "QR/IRN" && !catTwoAndThree && (
                          <div className="w-[60%]">
                            <Autocomplete
                              inputClassName="relative"
                              placeholder={key}
                              defaultValue={qrIRN}
                              suggestionList={[
                                { key: "QR", value: "QR" },
                                { key: "IRN", value: "IRN" },
                                { key: "BOTH", value: "BOTH" },
                              ]}
                              disabled={
                                category1 !== "Yes" && (
                                  data?.["E-Inv.Applicability"] === "No" ||
                                  [6, 8].includes(invoiceData?.fileStatusHdr?.fuid_status_id)
                                )
                              }
                              onSelectionChange={(e: any) => {
                                if (e === null) {
                                  setQrIRN(null);
                                  return;
                                }
                                setQrIRN(e.value);
                                //M10-11086
                                if (e.value === 'IRN' || e.value === 'BOTH') {
                                  setIRNValidation(true)
                                } else {
                                  setIRNValidation(false)
                                }
                                //M10-11086
                              }}
                              displayKey="key"
                            />
                            {/* M10-11086 */}
                            {IRNValidation &&
                              <span className="m-2 inline-flex items-center gap-2">
                                IRN Exemption :  <Toggle
                                  checked={IRNExempt}
                                  onChange={(e: any) => {
                                    setIRNExempt(e === true);
                                  }}
                                />
                              </span>
                            }
                            {/* M10-11086 */}
                          </div>
                        )}
                        {(qrIRN === "IRN" || qrIRN === "BOTH") && key === "Irn Number" && (
                          <div className="w-full mt-2">
                            <Input
                              enableArrows={false}
                              showIcon={false}
                              placeholder="IRN Number"
                              type="text"
                              value={irnNumber}
                              disabled={
                                (data?.["E-Inv.Applicability"] == "No" ||
                                  catTwoAndThree ||
                                  invoiceData?.fileStatusHdr?.fuid_status_id === 8 ||
                                  invoiceData?.fileStatusHdr?.fuid_status_id === 6) &&
                                (category1 == 'Yes' ? false : true)
                              }
                              onChange={(e: any) => setIrnNumber(e.target.value)}
                              className="w-full py-1 text-left border border-gray-300 rounded-lg"
                            />
                          </div>
                        )}
                        {key === "Invoice no." && (
                          <div className="w-[100%]">
                            <Input
                              disabled={invoiceData?.fileStatusHdr?.fuid_status_id === 8} //M10-11703
                              enableArrows={false}
                              showIcon={false}
                              placeholder={key}
                              type="text"
                              value={invoiceNumber}
                              onChange={handleInputChange}
                              className="w-full py-1 text-left border border-gray-300 rounded-lg"
                            />
                          </div>
                        )}

                        {key === "Invoice date" && (
                          <Input
                            disabled={invoiceData?.fileStatusHdr?.fuid_status_id === 8} //M10-11703
                            enableArrows={false}
                            showIcon={false}
                            placeholder={key}
                            type="date"
                            value={invoiceDate ? invoiceDate.split("T")[0] : value}
                            max={new Date().toISOString().split("T")[0]}
                            min={getTwoMonthsAgoDate()}
                            className="w-full py-1 text-left border border-gray-300 rounded-lg"
                            onChange={(e: any) => {
                              const dateValue = e.target.value;
                              // Parse the date from the input (expected format: YYYY-MM-DD)
                              const [year, month, day] = dateValue.split("-").map(Number);
                              // Get current UTC time parts
                              const now = new Date();
                              const utcHours = now.getUTCHours();
                              const utcMinutes = now.getUTCMinutes();
                              const utcSeconds = now.getUTCSeconds();
                              const utcMilliseconds = now.getUTCMilliseconds();
                              // Create a new Date using the selected date and current UTC time
                              const selectedDate = new Date(Date.UTC(year, month - 1, day, utcHours, utcMinutes, utcSeconds, utcMilliseconds));
                              const formattedDate = selectedDate.toISOString(); // Final UTC ISO string
                              setInvoiceDate(formattedDate);
                            }}

                          />
                        )}
                        {key == "MCI Validated" && (
                          <div className="w-[60%]">
                            <Toggle
                              disabled={
                                invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 6
                                // !data?.["MCI no."]?.trim()?.length
                              }
                              checked={mciValid == "Yes"}
                              onChange={(e: any) => {
                                setMciValid(e === true ? "Yes" : "No");
                              }}
                            />
                          </div>
                        )}
                        {key === "Order Code" &&
                          value?.split(",").map((orderCode, index) => {
                            const trimmedCode = orderCode.trim();
                            return (
                              <span key={index}>
                                <a
                                  className="text-gray-900 hover:text-[#6b40d6] w-fit"
                                  href={`/transactions/orders/info/${trimmedCode}/1`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={() => {
                                    window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                                    window.localStorage.setItem("company_code", invoiceData?.company_code);
                                  }}
                                >
                                  {trimmedCode}
                                </a>
                                {index < value.split(",").length - 1 && ", "}
                              </span>
                            );
                          })}
                        {key == "Counter code" && (
                          <a
                            className="text-gray-900 hover:text-[#6b40d6]"
                            href={`/masters/counters/details/?counter_code=${value}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              dispatch(counterActions.setClickType("row"));
                              dispatch(counterActions.setSelectedCounterData({}));
                              window.localStorage.setItem("counterOrderId", value);
                              window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                            }}
                          >
                            {value}
                          </a>
                        )}
                        {key !== "QR/IRN" &&
                          key !== "DL Present" &&
                          key !== "GST Applicability" &&  //M10-11546
                          key !== "MCI Validated" &&
                          key !== "E-Inv" &&
                          key !== "Stamp & Sign Status" &&
                          key !== "Irn Number" &&
                          key !== "Invoice no." &&
                          key !== "Invoice date" &&
                          key !== "Order Code" &&
                          key !== "Po Proportionate Exempt" &&  //M10-11703
                          key !== "Counter code" && (
                            <div className="mr-auto">
                              {checkDataType && <p className="text-[#1B1A1F] mr-auto">{typeof value === "string" ? verifyStringType(value) : ""}</p>}
                              {!checkDataType && <p className="text-[#1B1A1F] mr-auto">{value}</p>}
                            </div>
                          )}
                        {/* M10-11703 */}
                        {key == "Po Proportionate Exempt" && (
                          <>
                            {
                              invoiceData?.invoice?.invoiceProducts.some((item: any) =>
                                item?.orderProductMappings.some((m: any) => m.is_po_generated === false)
                              ) ? (
                                <div className="w-[60%]">
                                  <Toggle
                                    disabled={invoiceData?.fileStatusHdr?.fuid_status_id !== 8}
                                    checked={poProportionate === "Yes"}
                                    onChange={() => {
                                      setIsPoProportionate(true);
                                    }}
                                  />
                                </div>
                              ) : (
                                <div>-</div>
                              )
                            }
                          </>
                        )}
                        {/* M10-11703 */}
                      </div>
                    )
                )}
            </div>
          </div>
          <div className="flex items-center justify-end mb-10 gap-x-4">
            {!invoiceData?.invoice && <p className="text-gray-700">Please submit the invoice header first!</p>}

            {/* M10-10941 Only (Yet To Process,Waiting For Approval,On Hold)*/}
            {[1, 6, 4].includes(invoiceData?.fileStatusHdr?.fuid_status_id) && isMapped && ( //M10-11117
              <Button
                className="h-9 px-6 text-white font-normal bg-[#8051FF] shadow-sm transition hover:bg-[#6b40d6]"
                type="submit"
                onClick={handleSubmitInvoice}
                isLoading={isLoading}
                disabled={isRequestInProgress.current}
                module={
                  invoiceData?.invoice
                    ? fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].module
                    : fineGrainedPermissionsKeys.INVOICE.SUBMITINVOICE.module
                }
                action={
                  invoiceData?.invoice
                    ? fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].action
                    : fineGrainedPermissionsKeys.INVOICE.SUBMITINVOICE.action
                }
              >
                {invoiceData?.invoice ? "Update Invoice" : "Submit Invoice"}
              </Button>
            )}
          </div>
        </div>
      )
      }
      <Modal isOpen={escalateToMasterOpen} isHeader={false} onCloseModal={() => setEscalateToMasterOpen(false)}>
        <EscalateToMaster
          onSuccess={() => {
            // navigate("/transactions/invoice/0");
          }}
          onCloseModal={() => setEscalateToMasterOpen(false)}
        />
      </Modal>
      {/* M10-11703 */}
      <Modal isOpen={isPoProportionate} isHeader={false} onCloseModal={() => setIsPoProportionate(false)}>
        <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-normal py-1 font-semibold text-[#49484C]">Proportionate Exempt for PO</p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsPoProportionate(false)}>
              <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
            </Button>
          </div>
          <div>
            <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Reason</p>
            <Input
              type="text"
              placeholder="Enter Reason"
              value={poReason}
              onChange={(e) => {
                setPoReason(e.target.value)
              }}
              className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
            />
          </div>

          <Button loaderSize="small" isLoading={isLoading} className="text-white bg-[#8051FF] mt-2" onClick={handleSubmitInvoice}>
            Save Changes
          </Button>
        </div>
      </Modal>
      {/* M10-11703 */}
    </div >
  );
};

export default InvoiceDetailCard;
